const deals = require('./_deals');
const customfeed = require('./_customfeed');
const tags = require('./_tags');
const users = require('./_users');
const feed = require('./_feed');
const comments = require('./_comments');
const summaries = require('./_summaries');
const admin = require('./admin');

module.exports = {
	data() {
		return {
			limit: 10,
			loader: null,
			loaderController: null,
		};
	},
	mixins: [deals, customfeed, tags, users, feed, comments, summaries, admin],
	methods: {
		resetStatus() {
			this.loader = false;
		},
		helpers() {
			return {
				formatDeals(items, formatDescription = false) {
					const formatedDeals = [];

					items.forEach((deal) => {
						if (deal.sale_price) { deal.sale_price = parseFloat(deal.sale_price / 100).toString().replace('.', ','); }
						if (deal.old_price) { deal.old_price = parseFloat(deal.old_price / 100).toString().replace('.', ','); }
						if (deal.description && formatDescription) { deal.description = deal.description.replace(/<\/?[^>]+?>/gi, '').replace(/<\/?[a-z]+?$/i, ''); }

						formatedDeals.push(deal);
					});

					return formatedDeals;
				},
			};
		},
	},
};
